const timezones = [
  { label: 'Local Time', value: 'local' },
  { label: 'UTC (Universal Time)', value: 'UTC' },
  { label: 'GMT (Greenwich Mean Time)', value: 'GMT' },
  { label: 'Nigeria (WAT)', value: 'Africa/Lagos' },
  { label: 'Ghana (GMT)', value: 'Africa/Accra' },
  { label: 'South Africa (SAST)', value: 'Africa/Johannesburg' },
  { label: 'Egypt (EET)', value: 'Africa/Cairo' },
  { label: 'Kenya (EAT)', value: 'Africa/Nairobi' },
  { label: 'New York (EST)', value: 'America/New_York' },
  { label: 'Los Angeles (PST)', value: 'America/Los_Angeles' },
  { label: 'Chicago (CST)', value: 'America/Chicago' },
  { label: 'Mexico City (CST)', value: 'America/Mexico_City' },
  { label: 'São Paulo (BRT)', value: 'America/Sao_Paulo' },
  { label: 'London (GMT)', value: 'Europe/London' },
  { label: 'Berlin (CET)', value: 'Europe/Berlin' },
  { label: 'Paris (CET)', value: 'Europe/Paris' },
  { label: 'Moscow (MSK)', value: 'Europe/Moscow' },
  { label: 'Dubai (GST)', value: 'Asia/Dubai' },
  { label: 'India (IST)', value: 'Asia/Kolkata' },
  { label: 'China (CST)', value: 'Asia/Shanghai' },
  { label: 'Japan (JST)', value: 'Asia/Tokyo' },
  { label: 'South Korea (KST)', value: 'Asia/Seoul' },
  { label: 'Sydney (AEST)', value: 'Australia/Sydney' },
  { label: 'New Zealand (NZST)', value: 'Pacific/Auckland' },
  { label: 'GMT-12', value: 'Etc/GMT-12' },
  { label: 'GMT-11', value: 'Etc/GMT-11' },
  { label: 'GMT-10 (Hawaii)', value: 'Pacific/Honolulu' },
  { label: 'GMT-9', value: 'Etc/GMT-9' },
  { label: 'GMT-8 (PST)', value: 'Etc/GMT-8' },
  { label: 'GMT-7 (MST)', value: 'Etc/GMT-7' },
  { label: 'GMT-6 (CST)', value: 'Etc/GMT-6' },
  { label: 'GMT-5 (EST)', value: 'Etc/GMT-5' },
  { label: 'GMT-4', value: 'Etc/GMT-4' },
  { label: 'GMT-3', value: 'Etc/GMT-3' },
  { label: 'GMT-2', value: 'Etc/GMT-2' },
  { label: 'GMT-1', value: 'Etc/GMT-1' },
  { label: 'GMT+1 (WAT)', value: 'Etc/GMT+1' },
  { label: 'GMT+2 (SAST, EET)', value: 'Etc/GMT+2' },
  { label: 'GMT+3 (EAT, MSK)', value: 'Etc/GMT+3' },
  { label: 'GMT+4', value: 'Etc/GMT+4' },
  { label: 'GMT+5', value: 'Etc/GMT+5' },
  { label: 'GMT+6', value: 'Etc/GMT+6' },
  { label: 'GMT+7', value: 'Etc/GMT+7' },
  { label: 'GMT+8', value: 'Etc/GMT+8' },
  { label: 'GMT+9', value: 'Etc/GMT+9' },
  { label: 'GMT+10', value: 'Etc/GMT+10' },
  { label: 'GMT+11', value: 'Etc/GMT+11' },
  { label: 'GMT+12', value: 'Etc/GMT+12' },
];

export default timezones;
